import AllhomesListingPhotoCarousel, { BaseAllhomesListingPhotoCarousel } from './allhomes-listing-photo-carousel';
export default AllhomesListingPhotoCarousel;
export { BaseAllhomesListingPhotoCarousel };